module.exports = __webpack_public_path__ + "static/img/touxiang.3bd5eae3.jpg";